import { api, authHeaders } from "./core";

function reportFilename(header, fallback) {
  const match = /filename="?([^"]+)"?/i.exec(header || "");
  return match ? decodeURIComponent(match[1]) : fallback;
}

// JobFlow API for ordered job orchestration.
export const flowApi = {
  list() {
    return api("/api/jobflows");
  },

  get(id) {
    return api(`/api/jobflows/${id}`);
  },

  create(payload) {
    return api("/api/jobflows", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  update(id, payload) {
    return api(`/api/jobflows/${id}`, {
      method: "PUT",
      body: JSON.stringify(payload),
    });
  },

  remove(id) {
    return api(`/api/jobflows/${id}`, { method: "DELETE" });
  },

  bind(id, payload) {
    return api(`/api/jobflows/${id}/bind`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  run(id) {
    return api(`/api/jobflows/${id}/run`, { method: "POST" });
  },

  stress(id, payload) {
    return api(`/api/jobflows/${id}/stress`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  async exportReport(id) {
    const response = await fetch(`/api/jobflows/${id}/report`, {
      method: "POST",
      headers: authHeaders(),
    });
    if (!response.ok) {
      let data = {};
      try {
        data = await response.json();
      } catch (error) {
        data = {};
      }
      throw new Error(data.detail ? `${data.error || "请求失败"}：${data.detail}` : data.error || "请求失败");
    }

    return {
      filename: reportFilename(response.headers.get("Content-Disposition"), `flow_${id}_report.md`),
      content: await response.text(),
    };
  },
};
